var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container center",class:{ noHeight: _vm.noHeight, single: _vm.single }},[_c('div',{staticClass:"loading col"},[_c('font-awesome-icon',{staticClass:"loading-spinner",attrs:{"icon":['fas', 'fa-spinner'],"size":"xl"}}),_c('label',{class:{ small: _vm.small }},[_vm._v("Loading...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }